import type { CSSProperties } from 'react'

const BG_PALETTE = [
  '#E63946',
  '#F4B942',
  '#2ECC71',
  '#2481CC',
  '#7A5AE0',
  '#C87941',
] as const

export type AvatarSize = 24 | 32 | 48 | 64 | 96

export interface AvatarProps {
  name?: string
  size?: AvatarSize
  color?: string
  photo_url?: string
  style?: CSSProperties
}

export function Avatar({
  name = '?',
  size = 32,
  color,
  photo_url,
  style,
}: AvatarProps) {
  const initial = (name || '?').trim().charAt(0).toUpperCase()
  const idx = (name.charCodeAt(0) || 0) % BG_PALETTE.length
  const bg = color ?? BG_PALETTE[idx]

  const avatarStyle: CSSProperties = {
    width: size,
    height: size,
    background: photo_url
      ? `center/cover no-repeat url(${photo_url})`
      : bg,
    fontSize: Math.round(size * 0.42),
    ...style,
  }

  return (
    <div className="avatar" style={avatarStyle}>
      {photo_url == null && initial}
    </div>
  )
}
